// extracted by mini-css-extract-plugin
module.exports = {"CheckboxButton":"classes_CheckboxButton__26zt1","buttonCheckBox2":"classes_buttonCheckBox2__3E6V_"};